import { Input } from "../ui/input";
import { Label } from "../ui/label";

interface SnowflakeInputProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
}

export function SnowflakeInput({
  label,
  value,
  onChange,
  placeholder,
  className,
}: SnowflakeInputProps) {
  return (
    <div className={className}>
      <Label className="mb-1.5 block text-xs text-overlay1">{label}</Label>
      <Input
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder ?? "snowflake"}
      />
    </div>
  );
}
